<template>
  <div class="view box grow" style="overflow-y: auto;">
    <page-headers :header="'Settings'" :breadcrumbs="breadcrumbs" documentation="page-settings" class="box" />
    <el-tabs class="ml-20" v-model="activeTab" @tab-click="switchView">
      <el-tab-pane label="Users" name="users"> <users ref="users"></users> </el-tab-pane>
      <el-tab-pane label="SMTP" name="smtp"> <smtp-setting ref="smtpRef"></smtp-setting> </el-tab-pane>
      <el-tab-pane label="SSO" name="idp" v-if="$allow('users', 'write')">
        <idp-setting ref="idpRef"></idp-setting>
      </el-tab-pane>
      <el-tab-pane label="Slack Integration" name="slack" v-if="$allow('users', 'write')">
        <slack-setting />
      </el-tab-pane>
      <el-tab-pane label="Jira Configuration" name="jira-configurations" v-if="$allow('users', 'write')">
        <jira-configurations />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { CARBON_BLACK_LOAD_SYSTEM_PREF } from '@/store/modules/system_pref/system-pref.type'

import PageHeaders from '@/components/layout/PageHeaders.vue'
import SmtpSetting from '@/views/admin/SMTPSetting.vue'
import IdpSetting from '@/views/admin/IdpSetting.vue'
import Users from '@/views/admin/Users.vue'
import SlackSetting from '@/views/admin/SlackSetting.vue'
import JiraConfigurations from '@/views/admin/JiraConfigurations.vue'

export default {
  name: 'Preferences',
  data () {
    return {
      breadcrumbs: [{ title: 'Configuration' }, { title: 'Settings' }],
      activeView: 'profile'
    }
  },
  mounted () {
    this.$store.dispatch(CARBON_BLACK_LOAD_SYSTEM_PREF)
  },
  computed: {
    ...mapGetters(['carbonBlackSystemPrefEnabled']),
    activeTab: {
      get: function () {
        return this.$route.query.view || 'smtp'
      },
      set: function (val) {}
    }
  },
  methods: {
    switchView (tab, event) {
      // fetch relevent information for active view
      this.$router.replace({
        query: {
          view: tab.paneName
        }
      })
    }
  },
  components: {
    PageHeaders,
    SmtpSetting,
    IdpSetting,
    Users,
    SlackSetting,
    JiraConfigurations
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.view {
  height: 100%;

  .el-tabs {
    height: calc(100%-50px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/admin/Preferences.vue